import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { App, Platform, NavController, MenuController } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { AuthService } from '../../app/shared/services/auth.service';
import { qrCodeService } from '../../app/shared/services/qrCode.service';
import { LastScansService } from '../../app/shared/services/lastScans.service';

import { RapportSansAccesComponent } from '../rapport-sans-acces/rapport-sans-acces';
import { ConnexionComponent } from '../connexion/connexion';
import { SavoirPlusComponent } from '../savoir-plus/savoir-plus';
import { DerniersScansComponent } from '../derniers-scans/derniers-scans';
import { RapportComponent } from '../rapport/rapport';
import { ElementVerifieComponent } from '../element-verifie/element-verifie';

@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})
export class HomepageComponent implements OnInit {
    @Output() emitHasLastScans = new EventEmitter();
    private token: any = {
        user: '',
        token: '',
        statut: ''
    };
    private isAuth: boolean = false;
    private hasLastScans: boolean = false;
    private loader: boolean = true;
    private isApp: boolean = true;

    constructor(
    private app: App,
     private platform: Platform,
     private barcodeScanner: BarcodeScanner,
     private ga: GoogleAnalytics,
     private navCtrl: NavController,
     private menuCtrl: MenuController,
     private authService: AuthService,
     private qrCodeService: qrCodeService,
     private lastScansService: LastScansService
    ) {
        this.platform.ready().then(_ => {
            // On track la vue pour GA
            this.ga.trackView('Home Page');
            this.isApp = (this.platform.is('core') || this.platform.is('mobileweb')) ? false : true;
        });
    }

    ngOnInit(): any {
        this.init();
    }

    async init(): Promise<any> {
        this.token = await this.authService.getToken();
        this.isAuth = (this.token !== null && this.token.token !== '');

        const liste = await this.lastScansService.getLastScans();
        if (liste !== null) {
            for (let i in liste) {
                if (liste[i].user === this.token.user) {
                    this.hasLastScans = true;
                }
            }
        }
        this.loader = false;
        this.authService.hasToken.subscribe((hasToken: boolean) => {                             
            if (!hasToken) {
                this.isAuth = false;
                this.token = {
                    user: '',
                    token: '',
                    statut: ''
                };
            }
        });
    }

    ionViewDidEnter(): any {
        this.platform.ready().then(_ => {            
            if(this.platform.is('core') || this.platform.is('mobileweb')) {
                this.app.setTitle('SOCOTEC Avantage, vérifiez la conformité de vos équipements');
            }
        });
    }

    scan(): any {
        this.barcodeScanner.scan().then((barcodeData: any) => {
            if (!barcodeData.cancelled) {
                this.loader = true;
                this.platform.ready().then(_ => {
                    this.ga.trackEvent('Scan QRCode', 'scan');
                });
                // const barcodeData = { text: 'https://easycheck.socotec.fr?id=Y00003' };
                // const barcodeData = { text: 'https://easycheck.socotec.fr?id=6R0X9VZ' };
                // const barcodeData = { text: 'https://easycheck.socotec.fr?id=3N5W1I' };
                this.qrCodeService.getScanQRCode(barcodeData.text).subscribe(async (scan: any) => {
                    this.token = await this.authService.getToken();
                    if (this.token.token !== '') {
                        // Si l'user a les droits pour lire le rapport 
                        if (scan.data.perimetre !== undefined) {
                            // On ajoute le scan à la liste de l'user
                            await this.lastScansService.setLastScans(this.token.user, scan);
                            this.platform.ready().then(_ => {
                                if (barcodeData.text.match('socotec')) {
                                    this.ga.trackEvent('QRCode valide SOCOTEC', 'scan');
                                } else
                                    this.ga.trackEvent('QRCode valide Non SOCOTEC', 'scan');
                            });
                            if (scan.qrCodeType == 'Installation') {
                                this.goToPage('rapport');
                            } else {
                                this.goToPage('element-verifie');
                            }
                        } else {
                            // On récupère le refresh token
                            const refresh = await this.authService.getRefreshToken();
                            // Si le refresh token existait
                            if (refresh !== null) {
                                // On va récupérer un nouveau token
                                this.authService.refresh(refresh).subscribe( async (newToken: any) => {
                                    await this.authService.setToken(this.token.user, newToken.access_token, newToken.statut);
                                    await this.authService.setRefreshToken(newToken.refresh_token);
                                    this.qrCodeService.getScanQRCode(barcodeData.text).subscribe( async (scan: any) => {
                                        await this.lastScansService.setLastScans(this.token.user, scan);
                                        this.loader = false;
                                        this.platform.ready().then(_ => {
                                            if (barcodeData.text.match('socotec')) {
                                                this.ga.trackEvent('QRCode valide SOCOTEC', 'scan');
                                            } else {
                                                this.ga.trackEvent('QRCode valide Non SOCOTEC', 'scan');
                                            }
                                        });
                                        if (scan.qrCodeType == 'Installation') {
                                            this.goToPage('rapport');
                                        } else {
                                            this.goToPage('element-verifie');
                                        }
                                    });
                                });
                            } else {
                                await this.authService.removeToken();
                                await this.authService.removeRefreshToken();
                                this.platform.ready().then(_ => {
                                    if (barcodeData.text.match('socotec')) {
                                        this.ga.trackEvent('QRCode valide SOCOTEC', 'scan');
                                    } else {
                                        this.ga.trackEvent('QRCode valide Non SOCOTEC', 'scan');
                                    }
                                });
                                this.menuCtrl.enable(true, 'unauthenticated');
                                this.menuCtrl.enable(false, 'authenticated');
                                this.goToPage('rapport-sans-acces', scan);
                            }
                        }
                    } else {
                        this.platform.ready().then(_ => {
                            if (barcodeData.text.match('socotec')) {
                                this.ga.trackEvent('QRCode valide SOCOTEC', 'scan');
                            } else {
                                this.ga.trackEvent('QRCode valide Non SOCOTEC', 'scan');
                            }
                        });
                        this.goToPage('rapport-sans-acces', scan);
                    }
                }, (error: any) => {
                    console.error(error);
                    this.loader = false;
                    this.platform.ready().then(_ => {
                        if (error.status == 403) {
                            this.ga.trackEvent('QRCode permission refusée', 'scan');
                        } else if(error.status == 404) {
                            this.ga.trackEvent('QRCode invalide', 'scan');
                        }
                    });
                });
            }
        }, (error: any) => {
            // An error occurred
            console.error('error', error);
        });
    }

    goToPage(page: string, data?: any): any {
        if (page == 'rapport-sans-acces') {
            this.navCtrl.push(RapportSansAccesComponent, { data: data || {} });
        } else if (page == 'connexion') {
            this.navCtrl.push(ConnexionComponent);
        } else if (page == 'savoir-plus') {
            this.navCtrl.push(SavoirPlusComponent);
        } else if (page == 'derniers-scans') {
            this.navCtrl.push(DerniersScansComponent);
        } else if (page == 'rapport') {
            this.navCtrl.push(RapportComponent);
        } else if (page == 'element-verifie') {
            this.navCtrl.push(ElementVerifieComponent);
        }
    }

    callNumber(): any {
        window.location.href = 'tel: 0800802402';
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts